import React, { Component } from 'react'
import { CCard, CCardHeader, CCol, CPagination, CPaginationItem, CRow, CSpinner } from '@coreui/react'
import { rowsPerPage } from 'src/data/Data'

export default class Pagination extends Component {

    constructor(props) {
        super(props)

        this.state = {
            prevEnabled: false,
            nextEnabled: false,
            numberOfBox: 0,
            selectedBox: 1
        }
    }

    componentDidMount() {

        this.setState({
            numberOfBox: Math.ceil(this.props.totalRows / rowsPerPage)
        }, () => {
            this.enablePrevButton();
            this.enableNextButton();
        });
    }

    enablePrevButton() {

        if (this.state.selectedBox > 1) {
            this.setState({
                prevEnabled: true
            });
        }
        else {
            this.setState({
                prevEnabled: false
            });
        }
    }

    enableNextButton() {

        if (this.state.selectedBox < this.state.numberOfBox) {
            this.setState({
                nextEnabled: true
            });
        }
        else {
            this.setState({
                nextEnabled: false
            });
        }
    }

    prevAction() {

        var selectedBox = this.state.selectedBox - 1;

        if (selectedBox < 1) {
            selectedBox = 1;
        }

        this.setState({
            selectedBox: selectedBox
        }, () => {
            this.enableNextButton();
            this.enablePrevButton();
            this.handlePageChange();
        });
    }

    nextAction() {

        var selectedBox = this.state.selectedBox + 1;

        if (selectedBox > this.state.numberOfBox) {
            selectedBox = this.state.numberOfBox;
        }

        this.setState({
            selectedBox: selectedBox
        }, () => {
            this.enableNextButton();
            this.enablePrevButton();
            this.handlePageChange();
        });
    }

    selectBox(i) {

        if (i != this.state.selectedBox) {

            this.setState({
                selectedBox: i
            }, () => {
                this.enableNextButton();
                this.enablePrevButton();
                this.handlePageChange();
            });
        }
    }

    handlePageChange() {
        var start = (this.state.selectedBox - 1) * rowsPerPage;
        this.props.onPageChange(start);
    }

    render() {

        var rows = [];
        for (var i = 1; i <= this.state.numberOfBox; i++) {

            const pos = i;
            rows.push(
                <CPaginationItem
                    active={i == this.state.selectedBox}
                    onClick={() => {this.selectBox(pos)}}>
                    {pos}
                </CPaginationItem>
            );
        }

        const start = ((this.state.selectedBox - 1) * rowsPerPage) + 1;
        var end = rowsPerPage;
        if (end > this.props.displayedRowCount) {
            end = this.props.displayedRowCount;
        }

        end = start + end - 1;

        return (

            rows.length > 0 ?
                <CRow>
                    <CCol xs={12} style={{textAlign: 'end'}}>
                        {
                            !this.props.isDataLoading ?
                                <h6 style={{display: 'inline-block', marginRight: 20, color: "#0000a1"}}>Showing {start} to {end} of {this.props.totalRows} entries</h6>
                            : 
                                <CSpinner color="primary" size='sm' style={{marginRight: 20}} />
                        }
                        
                        <CPagination className="justify-content-end" aria-label="Pagination" style={{display: 'inline-block'}}>
                            <CPaginationItem
                                aria-label="Previous"
                                disabled={!this.state.prevEnabled}
                                onClick={() => this.prevAction()}>
                                <span aria-hidden="true">&laquo;</span>
                            </CPaginationItem>
                            {rows}
                            <CPaginationItem
                                aria-label="Next"
                                disabled={!this.state.nextEnabled}
                                onClick={() => this.nextAction()}>
                                <span aria-hidden="true">&raquo;</span>
                            </CPaginationItem>
                        </CPagination>
                    </CCol>
                </CRow>
                : null
        )
    }
}
